export default {
    AlphaNumericRegex: /^[a-zA-Z0-9]*$/,
    AlphaNumericPlusLimitedSpecialCharsRegex: /^[a-zA-Z0-9!"#$%'()+/:;\\<=>?@_`^~\-.&, ]+$/,
    NumericRegex: /^[0-9]*$/,
    EmailRegex: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/, // a single email address
    EmailListRegex:
        /^([a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)(;? *)?){0,10}$/, // up to 10 email addresses separated by a colon and/or spaces
    ExchangeFeeRegex: /^\d?\.\d{1,4}$/,
};
